import React from 'react'
import { cn } from '@/utilities/ui'

export function HorizontalSplit({
  className,
  left,
  right,
  leftFullBleed = false,
  rightFullBleed = false,
  leftClassName,
  rightClassName,
  rightContentClassName,
}: {
  className?: string
  left: React.ReactNode
  right: React.ReactNode
  leftClassName?: string
  rightClassName?: string
  leftFullBleed?: boolean
  rightFullBleed?: boolean
  rightContentClassName?: string
}) {
  return (
    <section className={cn('flex flex-col lg:flex-row', className)}>
      {leftFullBleed ? (
        <div className={cn('relative flex-1 bg-rock-1', leftClassName)}>
          <div className={cn('px-0', 'lg:px-4 lg:container-half lg:ml-auto lg:mr-0 lg:h-full')}>
            <div className="lg:absolute top-0 left-0 w-full h-full">{left}</div>
          </div>
        </div>
      ) : (
        <div className={cn('flex-1 bg-rock-1 py-[80px]', leftClassName)}>
          <div
            className={cn(
              'px-4',
              'container mx-auto',
              'lg:container-half lg:ml-auto lg:mr-0 lg:h-full',
            )}
          >
            <div className="lg:pr-[50px] h-full">{left}</div>
          </div>
        </div>
      )}
      {rightFullBleed ? (
        <div className={cn('relative flex-1 bg-paper-1', rightClassName)}>
          <div className={cn('px-0', 'lg:px-4 lg:container-half lg:ml-0 lg:mr-auto lg:h-full')}>
            <div className="lg:absolute top-0 left-0 w-full h-full">{right}</div>
          </div>
        </div>
      ) : (
        <div className={cn('flex-1 bg-paper-1 py-[80px]', rightClassName)}>
          <div
            className={cn(
              'px-4',
              'container mx-auto',
              'lg:container-half lg:ml-0 lg:mr-auto lg:h-full',
            )}
          >
            <div className={cn('lg:pl-[50px] h-full', rightContentClassName)}>{right}</div>
          </div>
        </div>
      )}
    </section>
  )
}
